<template>
  <div>
    <v-list-tile :to="item.shortName" :disabled="disableNavPoint">
      <v-list-tile-action>
        <v-icon :class="item.cssClass">{{item.icon}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{item.title}}</v-list-tile-title>
        <v-list-tile-sub-title v-if="showUsage">{{item.usage}}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </div>
</template>

<script>
  import geoTypes from '@/components/converter/helpers/geoTypes';

  export default {
    name: 'navigation',
    props: {
      item: {
        type: Object,
        required: true,
      },
      showUsage: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        geoTypes,
      };
    },
    computed: {
      disableNavPoint() {
        return this.$route.name === this.item.shortName;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue